// extracted by mini-css-extract-plugin
export default {"color":"sMb3bjHWa8","header":"noIaKk9GvZ","label":"G6ARrs1NOq","field":"zy0wKLOxly","remove":"c6Kpdss8DF","dark":"xm0yxfOH8l"};